<template>
	<div class="pagination">
		<slot></slot>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},

	props: {},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.pagination {
	grid-column: span 3;
	margin-bottom: $spacer * 4;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	column-gap: $spacer;
	padding-top: $spacer * 4;
	border-top: 1px solid $cpmec-blue;
	position: relative;

	@media (max-width: $lg) {
		padding-top: $spacer;
		margin-bottom: $spacer;
	}

	.page-numbers {
		border: 1px solid $cpmec-blue;
		padding: $spacer / 4 $spacer / 2;
		display: grid;
		grid-template-columns: 1fr;
		justify-content: center;
		align-items: center;
		max-height: 25px;
		max-width: calc(100% - 82px);
		width: auto;
		text-decoration: none;
		column-gap: $spacer;

		@media (max-width: $lg) {
			width: auto;
		}

		&.next {
			padding: 0 $spacer * 2;
			height: 70px;
			max-height: 70px;
			position: absolute;
			right: 0;
			display: flex;

			@media (max-width: $lg) {
				position: relative;
				max-height: 25px;
				height: 25px;
				padding: $spacer / 4 $spacer / 2;
			}

			&:hover {
				&::after {
					width: 70px;
					transition: 0.2s ease all;
				}
			}

			&::after {
				content: '';
				background: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzAiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCA3MCAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTY5LjY2OSA5LjMzMjE4TDYxLjM3MzcgMEw2MC42MjYzIDAuNjY0MzY0TDY3Ljg4NjUgOC44MzIxNUgwVjkuODMyMTVINjcuODg2Nkw2MC42MjYzIDE4TDYxLjM3MzcgMTguNjY0NEw2OS42NjkgOS4zMzIxOFoiIGZpbGw9IiMxQjU5NTUiLz4KPC9zdmc+Cg==');
				background-size: initial;
				background-repeat: no-repeat;
				background-position: right center;
				display: inline-block;
				width: 35px;
				height: 35px;
				overflow: hidden;
				transition: 0.2s ease all;

				@media (max-width: $lg) {
					display: none;
				}
			}
		}

		&.prev {
			padding: 0 $spacer * 2;
			height: 70px;
			max-height: 70px;
			position: absolute;
			left: 0;
			display: flex;

			@media (max-width: $lg) {
				position: relative;
				max-height: 25px;
				height: 25px;
				padding: $spacer / 4 $spacer / 2;
			}

			&:hover {
				&::before {
					width: 70px;
					transition: 0.2s ease all;
				}
			}

			&::before {
				content: '';
				background: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzAiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCA3MCAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTS01LjI1ODk5ZS0wNSA5LjMzMjEyTDguMjk1MjUgMTguNjY0M0w5LjA0MjY0IDE3Ljk5OTlMMS43ODI0NSA5LjgzMjE1TDY5LjY2ODkgOS44MzIxNkw2OS42Njg5IDguODMyMTZMMS43ODIzNSA4LjgzMjE1TDkuMDQyNjUgMC42NjQzMDFMOC4yOTUyNSAtOS44ODI1NWUtMDVMLTUuMjU4OTllLTA1IDkuMzMyMTJaIiBmaWxsPSIjMUI1OTU1Ii8+Cjwvc3ZnPgo=');
				background-size: initial;
				background-repeat: no-repeat;
				background-position: left center;
				display: inline-block;
				width: 35px;
				height: 35px;
				overflow: hidden;
				transition: 0.2s ease all;

				@media (max-width: $lg) {
					display: none;
				}
			}
		}

		&.no-border {
			border: 0 solid transparent;
			padding: 0 $spacer;
			max-width: calc(100% - 40px);
			column-gap: 0;

			span {
				padding-bottom: $spacer / 2;
				border-bottom: 1px solid $cpmec-blue;
			}
		}

		&.is-product {
			border: 1px solid $cpmec-green;
			background: $cpmec-green;
			transition: 0.2s ease all;

			span {
				color: $cpmec-blue;
			}

			.arrow {
				svg {
					position: absolute;
					right: 0;
					path {
						fill: $cpmec-blue;
					}
				}
			}

			&:hover {
				border: 1px solid $cpmec-white;
				background: $cpmec-white;
				transition: 0.2s ease all;
			}
		}

		&:hover {
			cursor: pointer;
		}

		span {
			color: $cpmec-blue;
			font-size: 20px;
		}

		.arrow {
			position: relative;
			display: flex;
			flex-direction: row;
			align-items: center;
			overflow: hidden;
			width: 40px;
			height: 20px;
			transition: 0.2s ease all;

			&.active {
				width: 70px;
				transition: 0.2s ease all;
			}

			svg {
				position: absolute;
				right: 0;
				path {
					fill: $cpmec-blue;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/SitePagination.vue